import React from "react";
export const accordionDefault = {
  onExpand: () => {},
  expanded: false,
  loading: false
};
const context = /*#__PURE__*/React.createContext(accordionDefault);
context.displayName = "AccordionOrbitContext";
export const useAccordion = () => React.useContext(context);
export const {
  Consumer,
  Provider
} = context;